const CustomRadioBtn = {
    props: {
        title: {
            type: String,
            default: "",
        },

        name: {
            type: String,
            default: "",
        },

        radioId: {
            type: String,
            default: "",
        }, 

        value: {
            type: String,
            default: "",
        },

        checked: {
            type: Boolean,
            default: false,
        },

        modelValue: {
            type: [String, Number],
        },
    },

    data() {
        return {
            radio_value: false,
        };
    },

    created() {
        this.radio_value = this.modelValue;
    },

    watch: {
        modelValue: function () {
            this.radio_value = this.modelValue;
        },
    },

    methods: {
        onRadioChange(e) {
            this.$emit("update:modelValue", this.radio_value);
        },
    },

    template: /*html*/ `
    <div class="radio">
        <label>
            <input type="radio" :name="name" :id="radioId" v-model="radio_value" :value="value" :checked="checked" @change="onRadioChange">
        <div></div>
        <p>{{title}}</p>
        </label>
    </div>
  `,
};

export default CustomRadioBtn;
